export const faqs = [
  {
    question: "How many Tru or die chiraq nfts will there be?",
    answer: "There will be 10,000 minted for this collection.",
  },
  {
    question: "How much will it cost to mint this nft?",
    answer:
      "True or die Chiraq NFTs will be available for minting on ethereum network and the price is TBA",
  },
  {
    question: "When will the game be available?",
    answer:
      "Game is already developed we are adding finishing touches merging block chain with the game. Will launch by Christmas.",
  },
];
